module.exports = __webpack_public_path__ + "static/media/logo.4ae3bbc5.png";